




































import STextarea from '@/common/components/STextarea.vue';
import DynamicQuestionMixin from '@/tasks/mixins/dynamic-question';
import {defineComponent} from '@vue/composition-api';
import AiLoadingOverlay from '@/tasks/components/AiLoadingOverlay.vue';

export default defineComponent({
  name: 'UOttawaHowToTestBoylesLawFrench',
  components: {AiLoadingOverlay, STextarea},
  mixins: [DynamicQuestionMixin()],
  props: {
    isSubmitting: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      inputs: {
        howToTestBoylesLaw: null,
        language: 'en',
      },
      questions: [
        {
          en: 'In the space provided below, please describe how you plan to test Boyle’s Law. Be sure to provide enough information that any of your classmates could come in and successfully use the procedure that you described.',
          fr: 'Dans l’espace ci-dessous, décrivez comment vous vérifierez la loi de Boyle. Soyez certain d’inclure suffisamment d’information. Si vous l’avez bien fait, un de vos collègues doit être capable de rentrer avec votre procédure et réussir à compléter cette partie de l’expérience.',
        },
      ],
    };
  },
  methods: {
    getQuestionText(question: any): string {
      return this.inputs.language === 'en' ? question.en : question.fr;
    },
  },
});
